/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Third party that issues a payment method on PASS's behalf.
 *
 * Highnote issues the card types `vc`, `pc`, `ec` and `pec`; Stripe issues
 * `vstc`, `pstc`, `vspc` and `pspc`. A card type never appears under the
 * other provider.
 */
export type PaymentProvider =
  (typeof PaymentProvider)[keyof typeof PaymentProvider];

export const PaymentProvider = {
  highnote: "highnote",
  stripe: "stripe",
} as const;
